/**
 * Class description
 *
 * Created: 2018-03-06
 * @author jonas
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {DungeonQuestLayerConfig} from "../../config/DungeonQuestLayerConfig";
import {DungeonQuestGameAssets} from "../DungeonQuestGameAssets";
import {DungeonQuestLogo} from "./parts/DungeonQuestLogo";

export class DungeonQuestLogoAreaView extends BaseView {
    private _logoShakeContainer:PIXI.Container;
    private _plainTextLogo:PIXI.Text;
    private _plainGfx:PIXI.Graphics;
    private _plainContainer:PIXI.Container;

    get shakeObject():PIXI.DisplayObject {
        return this._logoShakeContainer;
    }

    private _layer:ScalableLayer;
    private _topPlate:PIXI.Sprite;
    private _logo:DungeonQuestLogo;
    private _logoSmall:PIXI.Sprite;
    private _logoPadding:number = 10;
    private _topPlateGlow:PIXI.Sprite;


    constructor() {
        super(ResourcesGroupName.MAIN);
        this._layer = StageManager.getLayer(DungeonQuestLayerConfig.LOGO_LAYER.name);
        this._layer.addChild(this);
    }


    protected initAnimations():void {
        this._logoShakeContainer = new PIXI.Container();
        this._plainContainer = new PIXI.Container();

        if(UserAgent.isMobile) {
            const topPlateTexture = GameResources.getTextures(DungeonQuestGameAssets.BG_DIVIDER)[0];
            this._topPlate = new PIXI.TilingSprite(topPlateTexture, topPlateTexture.width, 720);
            this._topPlate.anchor.set(1, 1);
            this._topPlate.position.set(0, 28);
            this._topPlate.rotation = 90 * PIXI.DEG_TO_RAD;
            this.addChild(this._topPlate);

            this._topPlateGlow = new PIXI.Sprite(GameResources.getTextures(DungeonQuestGameAssets.BG_DIVIDER_GLOW)[0]);
            this._topPlateGlow.anchor.set(1, 1);
            this._topPlateGlow.position.set(0, 28);
            this._topPlateGlow.rotation = 90 * PIXI.DEG_TO_RAD;
            this.addChild(this._topPlateGlow);


            this._logo = new DungeonQuestLogo();
            this._logo.visible = false;

            this._logoSmall = new PIXI.Sprite(GameResources.getTextures(DungeonQuestGameAssets.TOP_LOGO_SMALL)[0]);
            this._logoSmall.anchor.set(0.5, 0.5);
            this._logoSmall.visible = false;


            this._logoShakeContainer.addChild(this._logo);
            this._logoShakeContainer.addChild(this._logoSmall);


            /*const padding:number = 5;



            this._plainContainer.position.set(360,5);

            this._plainTextLogo = new PIXI.Text("DUNGEON QUEST",DungeonQuestTextStyles.PLAIN_LOGO_TEXT);
            this._plainTextLogo.anchor.set(0.5,0);
            this._plainTextLogo.position.set(0,padding);

            this._plainGfx = new PIXI.Graphics();
            this._plainGfx.beginFill(0x000000, 0.5);
            this._plainGfx.drawRoundedRect(-(this._plainTextLogo.width*0.5 +padding) ,0,this._plainTextLogo.width+padding*2,this._plainTextLogo.height+padding*2,this._plainTextLogo.height* 0.25);
            this._plainGfx.endFill();

            this._plainGfx.position.set(0,0);

            this._plainContainer.addChild(this._plainGfx);
            this._plainContainer.addChild(this._plainTextLogo);
            this.addChild(this._plainContainer);*/
        } else {
            this._logo = new DungeonQuestLogo();
            this._logo.visible = true;
            this._logo.position.set(975, 85);
            this._logo.scale.set(0.8, 0.8);
            this._logoShakeContainer.addChild(this._logo);
        }


        this.addChild(this._logoShakeContainer);


    }

    private onResizeMobile(resizeData:IResizeData):void {
        if(resizeData.orientation == Orientation.LANDSCAPE) {
            this._plainContainer.visible = true;
            return;
        }

        const divThickness:number = 2;
        this._logo.scale.set(1);
        let freeSpace = (this._layer.y / this._layer.scale.x) - divThickness;
        freeSpace = Math.max(0, freeSpace);

        const margin = freeSpace - this._logo.height;
        if(margin < this._logoPadding) {
            let scale = freeSpace / (this._logo.height + this._logoPadding * 2);
            this._logo.scale.set(scale);
        }

        this._logo.position.set(360, -freeSpace * 0.5 - divThickness);


        this._logo.visible = this._logo.scale.x > 0.8;
        this._logoSmall.visible = this._logo.scale.x <= 0.8;


        if(this._logoSmall.visible) {
            this._logoSmall.scale.set(1);
            const margin = freeSpace - this._logoSmall.height;
            if(margin < this._logoPadding) {
                let scale = freeSpace / (this._logoSmall.height + this._logoPadding * 2);
                this._logoSmall.scale.set(scale);
            }

            this._logoSmall.position.set(360, -freeSpace * 0.5 - divThickness);
            this._logoSmall.visible = this._logoSmall.scale.x > 0.5;
        }

        if(!this._logo.visible && !this._logoSmall.visible) {
            this._plainContainer.visible = true;
        } else {
            this._plainContainer.visible = false;
        }


    }

    private onResizeDesktop(resizeData:IResizeData):void {

    }


    protected onResize(resizeData:IResizeData):void {
        if(UserAgent.isMobile) {
            this.onResizeMobile(resizeData);
        } else {
            this.onResizeDesktop(resizeData);
        }

    }
}